 
function generateColorPalette(n) {
  console.time(`generateColorPalette(${n})`);
  const basePalette = [
    "#E57373", "#F4A261", "#F6C37F", "#FFF176", "#DCE775", "#AED581",
    "#81C784", "#4DD0E1", "#64B5F6", "#7986CB", "#BA68C8", "#F48FB1"
  ];

  function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n) =>
      l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    const toHex = (x) =>
      Math.round(x * 255)
        .toString(16)
        .padStart(2, "0");
    return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
  }

  if (n <= basePalette.length) {
    console.timeEnd(`generateColorPalette(${n})`);
    return basePalette.slice(0, n);
  }

  // Génère des couleurs supplémentaires
  const extraNeeded = n - basePalette.length;
  const extraColors = [];
  for (let i = 0; i < extraNeeded; i++) {
    const hue = (i * 360) / extraNeeded;
    extraColors.push(hslToHex(hue, 85, 60));
  }

  console.timeEnd(`generateColorPalette(${n})`);
  return [...basePalette, ...extraColors].slice(0, n);
}

export function loadGoogleCharts(callback) {
  const userLang = getUserLang();
  console.log("Langue détectée :", userLang);

  if (typeof google === "undefined") {
    const script = document.createElement("script");
    script.src = "https://www.gstatic.com/charts/loader.js";
    script.onload = () => {
      google.charts.load("current", {
        language: userLang,
        packages: ["corechart", "table", "geochart"],
      });
      google.charts.setOnLoadCallback(callback);
    };
    document.head.appendChild(script);
  } else {
    google.charts.load("current", {
      language: userLang,
      packages: ["corechart", "table", "geochart"],
    });
    google.charts.setOnLoadCallback(callback);
  }
}

function getUserLang() {
  const metaTag = document.querySelector('meta[name="current-user-lang"]');
  const lang = metaTag ? metaTag.content : document.documentElement.lang || "fr";
  return lang.toLowerCase().slice(0, 2);
}

function loadXLSXLibrary(callback) {
  if (typeof XLSX === "undefined") {
    const xlsxScript = document.createElement("script");
    xlsxScript.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
    xlsxScript.onload = callback;
    document.head.appendChild(xlsxScript);
  } else {
    callback();
  }
}

function exportChartDataAsCSV(rawData, filename = "graphique_export") {
  if (!Array.isArray(rawData) || rawData.length <= 2) {
    console.warn("Pas assez de données pour l'export CSV");
    return;
  }

  const headers = rawData[0];
  const dataRows = rawData.slice(2); // Ignore les deux premières lignes

  // Déterminer les index à exclure
  const excludedIndexes = [];
  headers.forEach((header, index) => {
    if (
      typeof header === "string" &&
      (header.toLowerCase().includes("lien_graphe") ||
        header.toLowerCase().includes("annotation"))
    ) {
      excludedIndexes.push(index);
    } else if (
      header &&
      typeof header === "object" &&
      (header.role === "annotation" || header.role === "link")
    ) {
      excludedIndexes.push(index);
    }
  });

  // Filtrer les headers
  const filteredHeaders = headers.filter(
    (_, idx) => !excludedIndexes.includes(idx)
  );
  let csvContent =
    filteredHeaders
      .map((h) => `"${typeof h === "object" ? h.role : h}"`)
      .join(",") + "\n";

  // Filtrer les lignes de données
  dataRows.forEach((row) => {
    const filteredRow = row.filter((_, idx) => !excludedIndexes.includes(idx));
    const line = filteredRow
      .map((item) => {
        if (typeof item === "object" && item !== null) {
          return `"${item.v || ""}"`;
        }
        return `"${item || ""}"`;
      })
      .join(",");
    csvContent += line + "\n";
  });

  const csvWithBom = "\uFEFF" + csvContent;
  const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}.csv`);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function exportChartDataAsXLSX(rawData, filename = "graphique_export") {
  if (!Array.isArray(rawData) || rawData.length <= 2) {
    console.warn("Pas assez de données pour l'export XLSX");
    return;
  }

  const headers = rawData[0];
  const dataRows = rawData.slice(2);

  const excludedIndexes = [];
  headers.forEach((header, index) => {
    if (
      typeof header === "string" &&
      (header.toLowerCase().includes("lien_graphe") ||
        header.toLowerCase().includes("annotation"))
    ) {
      excludedIndexes.push(index);
    } else if (
      header &&
      typeof header === "object" &&
      (header.role === "annotation" || header.role === "link")
    ) {
      excludedIndexes.push(index);
    }
  });

  const filteredHeaders = headers.filter(
    (_, idx) => !excludedIndexes.includes(idx)
  );
  const filteredDataRows = dataRows.map((row) =>
    row.filter((_, idx) => !excludedIndexes.includes(idx))
  );

  const sheetData = [filteredHeaders, ...filteredDataRows];

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(sheetData);
  XLSX.utils.book_append_sheet(wb, ws, "Graphique");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function complementaryHex(hex) {
  // Convert HEX to RGB
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  // Calculer le complémentaire
  let compR = 255 - r;
  let compG = 255 - g;
  let compB = 255 - b;

  // Retourner le HEX du complémentaire
  return `#${compR.toString(16).padStart(2, "0")}${compG
    .toString(16)
    .padStart(2, "0")}${compB.toString(16).padStart(2, "0")}`;
}
function generateHarmoniousColors_old(baseHex, count) {
  function hexToHsl(hex) {
    let r = parseInt(hex.slice(1, 3), 16) / 255;
    let g = parseInt(hex.slice(3, 5), 16) / 255;
    let b = parseInt(hex.slice(5, 7), 16) / 255;

    let max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h *= 60;
    }
    return [h, s * 100, l * 100];
  }

  function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    let c = (1 - Math.abs(2 * l - 1)) * s;
    let x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    let m = l - c / 2;
    let [r, g, b] =
      h < 60
        ? [c, x, 0]
        : h < 120
        ? [x, c, 0]
        : h < 180
        ? [0, c, x]
        : h < 240
        ? [0, x, c]
        : h < 300
        ? [x, 0, c]
        : [c, 0, x];

    r = Math.round((r + m) * 255)
      .toString(16)
      .padStart(2, "0");
    g = Math.round((g + m) * 255)
      .toString(16)
      .padStart(2, "0");
    b = Math.round((b + m) * 255)
      .toString(16)
      .padStart(2, "0");

    return `#${r}${g}${b}`;
  }
  const baseColor = complementaryHex(baseHex);
  const goldenAngle = 137.5;
  let [h, s, l] = hexToHsl(baseColor);
  s = 80; // Saturation élevée
  l = 50; // Luminosité équilibrée

  const colors = new Set();
  for (let i = 0; colors.size < count; i++) {
    let hue = (h + i * goldenAngle) % 360;
    let color = hslToHex(hue, s, l);
    colors.add(color);
  }

  return [...colors];
}

export async function drawChartFromData(container, params = {}) {
  const rawData = JSON.parse(container.dataset.chartData || "[]");
  const customColor = container.dataset.chartColor || null;
  const dashId = params.dashId;

  if (!Array.isArray(rawData) || rawData.length < 3) {
    console.warn("Pas assez de données pour générer un graphique.");
    container.classList.add("no_record");
    container.style.height = "120px";
    container.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
        <div style="text-align: center; padding: 20px; border: 1px solid #ccc; border-radius: 5px; background-color: #f9f9f9;" class="mt-5">
          <i class="fas fa-hdd" style="font-size: 48px; color: #ccc;"></i>
          <p style="font-size: 14px;">Il n'y a pas de donnée à afficher.</p>
        </div>
      </div>
    `;
    return;
  }

  const headers = rawData[0];
  const chartType = rawData[1][0];
  const seriesType = rawData[1][1];
  
  // Traitement des données conditionnel selon le type de graphique
  let dataRows = rawData.slice(2);
  
  if (chartType === "PieChart") {
    // On filtre et trie uniquement pour PieChart
    dataRows = dataRows
      .filter(row => parseFloat(row[1]) > 0)
      .sort((a, b) => parseFloat(b[1]) - parseFloat(a[1]));
  }
  
  // Gestion du cas où il n'y a que des 0 même après filtre
  const pieDataEmpty =
    chartType === "PieChart" && dataRows.length === 0;
  
  if (pieDataEmpty) {
    container.classList.add("no_record");
    container.style.height = "120px";
    container.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
        <div style="text-align: center; padding: 20px; border: 1px solid #ccc; border-radius: 5px; background-color: #f9f9f9;" class="mt-5">
          <i class="fas fa-hdd" style="font-size: 48px; color: #ccc;"></i>
          <p style="font-size: 14px;">Il n'y a pas de donnée à afficher.</p>
        </div>
      </div>`;
    return;
  }
   
  
  const formattedHeaders = headers.map((label, i) => {
    if (label === "annotation") return { role: "annotation" };
    if (label === "lien_graphe") return { role: "link" };
    return label;
  });

  const dataArray = [formattedHeaders, ...dataRows];

  const data = google.visualization.arrayToDataTable(dataArray, false);

  const xLabels = dataRows.map((row) => row[0]);

  const chartWidth =
    params.chartWidth ?? (parseInt(container.dataset.chartWidth) || 350);
  const chartHeight =
    params.chartHeight ?? (parseInt(container.dataset.chartHeight) || 300);
  const chartAreaLeft =
    params.chartAreaLeft ?? (parseInt(container.dataset.chartAreaLeft) || 30);
  const chartAreaWidth =
    params.chartAreaWidth ??
    (parseInt(container.dataset.chartAreaWidth) || "95%");
  const chartAreaHeight =
    params.chartAreaHeight ??
    (parseInt(container.dataset.chartAreaHeight) || "75%");
  const chartGroupWidth =
    params.chartGroupWidth ??
    (parseInt(container.dataset.chartGroupWidth) || "85%");

  const options = {
    title: "",
    width: chartWidth,
    height: chartHeight,
    chartArea: {
      left: chartAreaLeft,
      top: 5,
      width: chartAreaWidth,
      height: chartAreaHeight,
    },
    legend: { position: "none" },
    pointSize: 4,
    bar: { groupWidth: chartGroupWidth },
    hAxis: {
      title: headers[0],
      slantedText: true,
      slantedTextAngle: 30,
      textStyle: {
        fontSize: 9,
        color: "#333",
      },
      showTextEvery: 1,
      maxAlternation: 1,
      maxTextLines: 1,
      ticks: xLabels.map((label) => ({ v: label, f: label })),
    },
    vAxis: {
      title:
        window.location.href.includes("/elabxrm/") ||
        window.location.href.includes("/katalyse_test/")
          ? headers[1]
          : "",
      format: "",
      gridlines: { count: 5 },
      textStyle: {
        fontSize: 9,
        color: "#333",
      },
    },
    annotations: {
      textStyle: {
        fontSize: 10,
        color: "#000",
        auraColor: "none",
      },
    },
  };

  let chart;
  const exportEl = container.parentElement.querySelector('[id$="_export"]');
  const containerId = container.id || "chart";
  switch (chartType) {
    case "ColumnChart":
      chart = new google.visualization.ColumnChart(container);
      if (customColor) {
        options.colors = [customColor];
      }
      break;
    case "ComboChart":
      chart = new google.visualization.ComboChart(container);
      options.seriesType = seriesType;

      if (customColor) {
        options.colors = [customColor];
      }
      break;
    case "LineChart":
      chart = new google.visualization.LineChart(container);
      if (customColor) {
        options.colors = [customColor];
      }
      break;
    case "PieChart":
      chart = new google.visualization.PieChart(container);
      options.is3D = true;
      options.legend = {
        position: "right",
        alignment: "center",
        textStyle: { fontSize: 11 },
      };
      options.chartArea = {
        left: 10,
        top: 10,
        width: "100%",
        height: "100%",
      };
      // const generatedColors = dataRows.map((_, index) => {
      //   return STATIC_COLOR_PALETTE[index % STATIC_COLOR_PALETTE.length];
      // });
      const generatedColors = generateColorPalette(dataRows.length);
      options.colors = generatedColors;

      break;

    case "Table":
      chart = new google.visualization.Table(container);
      options.allowHtml = true;
      break;

    case "GeoChart":
      chart = new google.visualization.GeoChart(container);
      options.datalessRegionColor = "#f0f0f0";
      options.defaultColor = customColor || "#3366cc";
      options.colorAxis = { colors: [customColor || "#5bc0de", "#004080"] };
      if (container.dataset.chartRegion === "FR") {
        options.region = "FR";
        options.resolution = "provinces";
        options.displayMode = "regions";
      }
      break;

    case "Maps":
      chart = new google.visualization.GeoChart(container);

      options.datalessRegionColor = "#f0f0f0";
      options.defaultColor = customColor || "#3366cc";
      options.colorAxis = {
        colors: [customColor || "#5bc0de", "#004080"],
      };
      options.displayMode = "markers";
      options.region = "FR";
      options.resolution = "provinces";
      options.sizeAxis = {
        minValue: 0,
        maxSize: 20,
      };
      options.tooltip = {
        textStyle: {
          fontSize: 12,
          bold: true,
          color: "#333",
        },
        showColorCode: true,
      };
      options.magnifyingGlass = {
        enable: true,
        zoomFactor: 7.5,
      };
      options.keepAspectRatio = true;
      options.backgroundColor = "#ffffff";
      break;
    case "GoogleMaps":
      if (typeof google.maps === "undefined") {
        console.warn("Google Maps API n'est pas chargée !");
        container.innerHTML = "Google Maps non disponible.";
        return;
      }

      container.innerHTML = "";

      const { Map } = await google.maps.importLibrary("maps");
      container.style.width = `${params.chartWidth || 500}px`;
      container.style.height = `${params.chartHeight || 300}px`;

      const map = new Map(container, {
        zoom: 5,
        center: { lat: 46.603354, lng: 1.888334 },
        mapTypeId: "roadmap",
        mapTypeControl: true,
        fullscreenControl: true,
        streetViewControl: true,
        styles: [
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          { featureType: "transit", stylers: [{ visibility: "off" }] },
        ],
      });

      dataRows.forEach((row) => {
        const label = row[0];
        const lat = parseFloat(row[1]);
        const lng = parseFloat(row[2]);

        if (!isNaN(lat) && !isNaN(lng)) {
          const marker = new google.maps.Marker({
            map: map,
            position: { lat, lng },
            title: label,
            icon: {
              url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
              scaledSize: new google.maps.Size(32, 32),
            },
          });

          const infoWindow = new google.maps.InfoWindow({
            content: `<strong>${label}</strong>`,
          });

          marker.addListener("click", () => {
            infoWindow.open(map, marker);
          });
        }
      });

      return;

    default:
      console.warn(`Type de graphique non reconnu: ${chartType}`);
      return;
  }
  google.visualization.events.addListener(chart, "ready", function () {
    if (
      exportEl &&
      chart.getImageURI &&
      typeof chart.getImageURI === "function"
    ) {
      const imageURI = chart.getImageURI();

      // Récupérer dynamiquement le titre
      const titleElement = document.querySelector(
        `#dash_result_${containerId} .title`
      );
      let titleText = titleElement
        ? titleElement.textContent.trim()
        : "graphique_export";

      titleText = titleText.replace(/[\/\\:*?"<>|]/g, "_").replace(/\s+/g, "_");

      const exportContainer = document.getElementById(`${containerId}_export`);
      const exportImageLabel =
        exportContainer?.dataset.exportImageLabel || "Exporter Image";
      const exportXlsxLabel =
        exportContainer?.dataset.exportXlsxLabel || "Exporter Excel";
      exportEl.innerHTML = `
      <span data-controller="tooltip" data-tooltip-target-id-value="tooltip-export-image-${containerId}">
        <a href="${imageURI}" download="${titleText}.png" class="export-button button-icon me-1">
          <i class="fas fa-image"></i>
        </a>
      </span>
      <div id="tooltip-export-image-${containerId}" style="display:none;">
        ${exportImageLabel}
      </div>
    
      <span data-controller="tooltip" data-tooltip-target-id-value="tooltip-export-xlsx-${containerId}">
        <button type="button" id="export-xlsx-${containerId}" class="export-button button-icon" style="color: #217346;">
          <i class="fas fa-file-excel" style="color: #217346;"></i>
        </button>
      </span>
      <div id="tooltip-export-xlsx-${containerId}" style="display:none;">
      ${exportXlsxLabel}
      </div>

    `;
      const exportCsvButton = document.getElementById(
        `export-csv-${containerId}`
      );
      if (exportCsvButton) {
        exportCsvButton.addEventListener("click", function () {
          exportChartDataAsCSV(rawData, titleText);
        });
      }
      const exportXlsxButton = document.getElementById(
        `export-xlsx-${containerId}`
      );
      if (exportXlsxButton) {
        exportXlsxButton.addEventListener("click", function () {
          loadXLSXLibrary(() => {
            exportChartDataAsXLSX(rawData, titleText);
          });
        });
      }
    }
  });

  chart.draw(data, options);

  google.visualization.events.addListener(chart, "select", function () {
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const row = selection[0].row;
      const linkIndex = formattedHeaders.findIndex(
        (h) => typeof h === "object" && h.role === "link"
      );

      if (linkIndex !== -1) {
        const url = data.getValue(row, linkIndex);
        if (!url) return;

        const jsonUrl = new URL(url, window.location.origin);

        if (jsonUrl.searchParams.get("as_json_format") === "1") {
          Fancybox.show([
            {
              src: `
              <div style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                background: transparent;
              ">
                <style>
                  .fancybox__content { background: transparent !important; box-shadow: none !important; }
                </style>
                <div class="fancybox__spinner" style="
                  width: 48px;
                  height: 48px;
                  border: 4px solid rgba(0, 0, 0, 0.1);
                  border-top-color: #000;
                  border-radius: 50%;
                  animation: fancybox-spin 1s linear infinite;
                "></div>
              </div>
            `,
              type: "html",
            },
          ]);

          fetch(jsonUrl, {
            headers: {
              Accept: "application/json",
            },
          })
            .then((response) => {
              if (!response.ok)
                throw new Error("Erreur HTTP " + response.status);
              return response.json();
            })
            .then((data) => {
              if (data.html) {
                Fancybox.close();
                Fancybox.show([{ src: data.html, type: "html" }]);
              } else {
                throw new Error("Aucun contenu HTML");
              }
            })
            .catch((error) => {
              console.error("Erreur lors du chargement dynamique :", error);
              Fancybox.close();
              Fancybox.show([
                {
                  src: `<div style="padding: 20px; text-align: center; color:red;">
                        ❌ Erreur de chargement : ${error.message}
                      </div>`,
                  type: "html",
                },
              ]);
            });
        } else {
          window.open(url, "_blank");
        }
      }
    }
  });
}
